import { content } from './content/index.js';
import { validateDeckPassiveSelection } from './deck-passive-catalog.js';
export const CONSTRUCTED_DECK_SLOT_LIMIT = 12;
export const STARTING_DECK_COPIES_PER_SLOT = 2;
/** Version of the persisted constructed-deck recipe/expansion rules. */
export const DECK_RULES_VERSION = 2;
function assertCardId(cardId) {
    if (typeof cardId !== 'string' || cardId.length === 0) {
        throw new Error('CardDefId должен быть непустой строкой');
    }
    return cardId;
}
function codeUnitCompare(left, right) {
    if (left < right)
        return -1;
    if (left > right)
        return 1;
    return 0;
}
export function validateConstructedDeck(recipe, source = content) {
    const { cardIds, passiveId } = recipe;
    const cards = source.cards;
    const issues = [];
    if (cardIds.length > CONSTRUCTED_DECK_SLOT_LIMIT) {
        issues.push(Object.freeze({
            code: 'DECK_TOO_MANY_SLOTS',
            actualSlots: cardIds.length,
            maximumSlots: CONSTRUCTED_DECK_SLOT_LIMIT,
        }));
    }
    else if (cardIds.length !== CONSTRUCTED_DECK_SLOT_LIMIT) {
        issues.push(Object.freeze({
            code: 'DECK_NOT_READY',
            actualSlots: cardIds.length,
            requiredSlots: CONSTRUCTED_DECK_SLOT_LIMIT,
        }));
    }
    const indexesByCard = new Map();
    cardIds.forEach((rawCardId, index) => {
        const cardId = assertCardId(rawCardId);
        const indexes = indexesByCard.get(cardId) ?? [];
        indexes.push(index);
        indexesByCard.set(cardId, indexes);
    });
    for (const [cardId, indexes] of [...indexesByCard].sort(([left], [right]) => codeUnitCompare(left, right))) {
        const card = cards.get(cardId);
        if (card === undefined) {
            issues.push(Object.freeze({
                code: 'DECK_UNKNOWN_CARD',
                cardId,
                slotIndexes: Object.freeze([...indexes]),
            }));
        }
        else if (card.role !== 'playable') {
            issues.push(Object.freeze({
                code: 'DECK_CARD_NOT_PLAYABLE',
                cardId,
                role: card.role,
                slotIndexes: Object.freeze([...indexes]),
            }));
        }
    }
    const passiveValidation = validateDeckPassiveSelection(passiveId, source);
    if (!passiveValidation.valid) {
        issues.push(Object.freeze(passiveValidation.code === 'UNKNOWN_PASSIVE'
            ? {
                code: 'DECK_UNKNOWN_PASSIVE',
                passiveId: passiveValidation.passiveId,
            }
            : {
                code: 'DECK_PASSIVE_NOT_AVAILABLE',
                passiveId: passiveValidation.passiveId,
                role: passiveValidation.role,
            }));
    }
    const frozenIssues = Object.freeze(issues);
    const hasInvalidSlot = frozenIssues.some((issue) => issue.code === 'DECK_UNKNOWN_CARD' || issue.code === 'DECK_CARD_NOT_PLAYABLE'
        || issue.code === 'DECK_UNKNOWN_PASSIVE' || issue.code === 'DECK_PASSIVE_NOT_AVAILABLE');
    const draftValid = cardIds.length <= CONSTRUCTED_DECK_SLOT_LIMIT && !hasInvalidSlot;
    return Object.freeze({
        draftValid,
        ready: cardIds.length === CONSTRUCTED_DECK_SLOT_LIMIT && !hasInvalidSlot,
        issues: frozenIssues,
    });
}
/** Stable ECMAScript code-unit multiset order; authored/presentation order is ignored. */
export function canonicalizeDeckRecipe(cardIds) {
    return Object.freeze(cardIds.map(assertCardId).sort(codeUnitCompare));
}
export function expandCanonicalDeckRecipe(canonicalRecipe) {
    return Object.freeze(canonicalRecipe.flatMap((cardId) => {
        const exactCardId = assertCardId(cardId);
        return [exactCardId, exactCardId];
    }));
}
//# sourceMappingURL=constructed-deck.js.map